import { useMemo, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// project-imports
import MainCard from 'components/MainCard';
import IconButton from 'components/@extended/IconButton';
import Transitions from 'components/@extended/Transitions';

import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';

// assets
import { LanguageSquare, Setting2 } from 'iconsax-react';

// types
import { I18n } from 'types/config';
import { Fab } from '@mui/material';
import ThemeModeLayout from 'components/Customization/ThemeMode';


// ==============================|| HEADER CONTENT - LOCALIZATION ||============================== //

export default function Localization() {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  

  const { mode, i18n, onChangeLocalization } = useConfig();
  const themeMode = useMemo(() => <ThemeModeLayout />, [mode]);

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };


  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (lang: I18n) => {
    onChangeLocalization(lang);
    setOpen(false);
  };

  const iconBackColorOpen = mode === ThemeMode.DARK ? 'background.paper' : 'secondary.200';
  const iconBackColor = mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';
  

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5, display: 'flex', alignItems: 'center'  }}>
      <Grid item xs={12} sx={{ mr: 2 }}> {/* Aggiungi margine destro */}
    {themeMode}
  </Grid>

  <IconButton
    color="secondary"
    variant="light"
    aria-label="open localization"
    ref={anchorRef}
    aria-controls={open ? 'localization-grow' : undefined}
    aria-haspopup="true"
    onClick={handleToggle}
    size="large"
    sx={{ color: 'secondary.main', bgcolor: open ? iconBackColorOpen : iconBackColor, p: 1 }}

      
    >
      <LanguageSquare variant="Bulk" />
    </IconButton>
    <Popper
      placement={matchesXs ? 'bottom-start' : 'bottom'}
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      popperOptions={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [matchesXs ? 0 : 0, 9]
            }
          }
        ]
      }}
    >
      {({ TransitionProps }) => (
        <Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
          <Paper sx={{ boxShadow: theme.customShadows.z1, borderRadius: 1.5 }}>
            <ClickAwayListener onClickAway={handleClose}>
              <MainCard border={false} content={false}>
                <List
                  component="nav"
                  sx={{
                    p: 1,
                    width: '100%',
                    minWidth: 200,
                    maxWidth: 290,
                    bgcolor: theme.palette.background.paper,
                    [theme.breakpoints.down('md')]: { maxWidth: 250 }
                  }}
                >
                  <ListItemButton selected={i18n === 'en'} onClick={() => handleListItemClick('en')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="text.primary">English</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ ml: '8px' }}>
                            (UK)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                  {/* <ListItemButton selected={i18n === 'fr'} onClick={() => handleListItemClick('fr')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="text.primary">français</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ ml: '8px' }}>
                            (French)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton> */}
                  {/* <ListItemButton selected={i18n === 'ro'} onClick={() => handleListItemClick('ro')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="text.primary">Română</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ ml: '8px' }}>
                            (Romanian)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton> */}
                  {/* <ListItemButton selected={i18n === 'zh'} onClick={() => handleListItemClick('zh')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="text.primary">中国人</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ ml: '8px' }}>
                            (Chinese)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton> */}
                  <ListItemButton selected={i18n === 'it'} onClick={() => handleListItemClick('it')}>
                    <ListItemText
                      primary={
                        <Grid container>
                          <Typography color="text.primary">Italiano</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ ml: '8px' }}>
                            (Italiano)
                          </Typography>
                        </Grid>
                      }
                    />
                  </ListItemButton>
                </List>
              </MainCard>
            </ClickAwayListener>
          </Paper>
        </Transitions>
      )}
    </Popper>
  </Box>
    
);
}
      
        
      
      
      
          
